"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/csr.ts
var csr_exports = {};
__export(csr_exports, {
  OtelCarrier: () => OtelCarrier,
  handleFetchEvent: () => handleFetchEvent,
  handleInitEvent: () => handleInitEvent,
  handleRenderedEvent: () => handleRenderedEvent,
  loggerProvider: () => loggerProvider,
  setupCsrOtel: () => setupCsrOtel,
  updateCsrFeatureFlags: () => updateCsrFeatureFlags
});
module.exports = __toCommonJS(csr_exports);

// src/components/carrier.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var OtelCarrier = (props) => {
  const { traceCarrier, meterCarrier, featureFlags } = props;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
    traceCarrier && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "script",
      {
        id: "otel-trace-carrier",
        type: "application/json",
        dangerouslySetInnerHTML: { __html: `${JSON.stringify(traceCarrier)};` }
      }
    ),
    meterCarrier && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "script",
      {
        id: "otel-meter-carrier",
        type: "application/json",
        dangerouslySetInnerHTML: { __html: `${JSON.stringify(meterCarrier)};` }
      }
    ),
    featureFlags && /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      "script",
      {
        id: "otel-feature-flags",
        type: "application/json",
        dangerouslySetInnerHTML: { __html: `${JSON.stringify(featureFlags)};` }
      }
    ),
    traceCarrier && Object.entries(traceCarrier).map(
      ([key, value]) => value ? /* @__PURE__ */ (0, import_jsx_runtime.jsx)("meta", { name: key, content: value }, key) : null
    )
  ] });
};

// src/events/csr.ts
var import_api9 = require("@opentelemetry/api");

// src/constants/setup.ts
var import_semantic_conventions = require("@opentelemetry/semantic-conventions");
var import_uuid = require("uuid");
var isNodeRuntime = typeof window === "undefined" || !!process.env.NEXT_RUNTIME || typeof process === "object" && process.release?.name === "node";
var isJestRuntime = process.env.JEST_WORKER_ID !== void 0 || process.env.NODE_ENV === "test";
var isOtelBypass = typeof window !== "undefined" && window.location.search.includes("disable-otel");
var isOtelEnabled = !isOtelBypass && process.env.NEXT_PUBLIC_OTEL_ENABLED === "true";
var isOtelDebugLogging = process.env.NEXT_PUBLIC_OTEL_DEBUG_LOGGING === "true";
var isOtelExportLogging = process.env.NEXT_PUBLIC_OTEL_EXPORT_LOGGING === "true";
var tracesUrl = process.env.NEXT_PUBLIC_OTEL_TRACES_URL || "invalid-url";
var metricsUrl = process.env.NEXT_PUBLIC_OTEL_METRICS_URL || "invalid-url";
var loggingUrl = process.env.NEXT_PUBLIC_OTEL_LOGS_URL || "invalid-url";
var appName = process.env.NEXT_PUBLIC_OTEL_CLIENT_NAME || "invalid-app-name";
var metricsIntervalMs = Number(process.env.NEXT_PUBLIC_OTEL_METRICS_INTERVAL_MS ?? 12e4);
var clientType = process.env.NEXT_PUBLIC_OTEL_CLIENT_TYPE || "default-client-type";
var criticalPathsSampled = process.env.NEXT_PUBLIC_OTEL_CRITICAL_PATHS_SAMPLED || "default-critical-paths-sampled";
var loadSLOThreshold = Number(process.env.NEXT_PUBLIC_OTEL_SLO_THRESHOLD) || 2 * 1e3;
var isW3CSupported = process.env.NEXT_PUBLIC_OTEL_W3C_SUPPORT === "true";
var defaultTracesSampleRatio = Number(process.env.NEXT_PUBLIC_OTEL_TRACES_RATIO ?? 1);
var defaultUserId = (0, import_uuid.v4)();
var defaultBannerId = process.env.NEXT_PUBLIC_OTEL_BANNER || "invalid-banner";
var resourceAttributes = {
  [import_semantic_conventions.ATTR_SERVICE_NAME]: appName,
  "ld.lob": process.env.NEXT_PUBLIC_OTEL_LOB,
  "ld.banner": defaultBannerId,
  "ld.client.version": process.env.NEXT_PUBLIC_OTEL_CLIENT_VERSION
};
var defaultGCDurationBuckets = [
  2e-3,
  4e-3,
  8e-3,
  0.016,
  0.032,
  0.064,
  0.128,
  0.256,
  0.512,
  1.02,
  2.05,
  4.1,
  8.2,
  16.4,
  32.8
];
var defaultHeaders = {
  "Content-Type": "application/json"
};
var defaultFeatureFlags = { status: false, alwaysOnTracingUserIds: [], traceSamplingRatio: 0 };

// src/store/csr.ts
var import_zustand = require("zustand");
var import_middleware = require("zustand/middleware");
var import_immer = require("zustand/middleware/immer");
var import_immer2 = require("immer");
var useCsrStore = (0, import_zustand.create)()(
  (0, import_middleware.devtools)(
    (0, import_immer.immer)((set) => ({
      // state
      fetchEvents: [],
      // lifecycle
      initStore: () => set(
        () => ({
          fetchEvents: []
        }),
        void 0,
        "initStore"
      ),
      // events
      addFetchEvent: (newFetchEvent) => set(
        (state) => ({
          fetchEvents: [...state.fetchEvents, newFetchEvent]
        }),
        void 0,
        "addFetchEvent"
      )
    })),
    {
      name: "useCsrStore",
      store: "CsrStore",
      enabled: isOtelDebugLogging
    }
  )
);

// src/utils/metrics.ts
var import_api = require("@opentelemetry/api");
var meter = () => import_api.metrics.getMeter(`${appName}-meter`);
var getFetchEventsDuration = (fetchEvents) => {
  if (fetchEvents.length === 0) return 0;
  return fetchEvents.reduce((acc, event) => acc + (event.duration || 0), 0);
};
var getOpTotalCounter = (pageKey) => meter().createCounter(`${pageKey}_op_total`, {
  description: "Number of time page is accessed by the client (cumulative)",
  valueType: import_api.ValueType.INT
});
var getOpErrorsCounter = (pageKey) => meter().createCounter(`${pageKey}_op_errors`, {
  description: "Number of times page access yield error(s) (cumulative)",
  valueType: import_api.ValueType.INT
});
var getOpSloErrorsCounter = (pageKey) => meter().createCounter(`${pageKey}_op_slo_errors`, {
  description: "Number of times a route breached the SLO",
  valueType: import_api.ValueType.INT
});
var getOpAggregateErrorsCounter = (pageKey) => meter().createCounter(`${pageKey}_op_aggregate_errors`, {
  description: "Number of times either an error or SLO breach occurred during page load",
  valueType: import_api.ValueType.INT
});
var getOpNetworkDurationHistogram = (pageKey) => meter().createHistogram(`${pageKey}_op_network_duration`, {
  description: "Total latency of REST calls for page (cumulative) ",
  valueType: import_api.ValueType.DOUBLE,
  advice: {
    explicitBucketBoundaries: defaultGCDurationBuckets
  }
});
var getOpDurationHistogram = (pageKey) => meter().createHistogram(`${pageKey}_op_duration`, {
  description: "Total time to render complete of the page (cumulative) ",
  valueType: import_api.ValueType.DOUBLE,
  advice: {
    explicitBucketBoundaries: defaultGCDurationBuckets
  }
});

// src/utils/otel-logger.ts
var import_api8 = require("@opentelemetry/api");
var import_api_logs = require("@opentelemetry/api-logs");

// src/setup/csr.ts
var import_api7 = require("@opentelemetry/api");
var import_core5 = require("@opentelemetry/core");
var import_exporter_metrics_otlp_http2 = require("@opentelemetry/exporter-metrics-otlp-http");
var import_exporter_trace_otlp_http = require("@opentelemetry/exporter-trace-otlp-http");
var import_instrumentation3 = require("@opentelemetry/instrumentation");
var import_propagator_b3 = require("@opentelemetry/propagator-b3");
var import_resources = require("@opentelemetry/resources");
var import_sdk_logs = require("@opentelemetry/sdk-logs");
var import_sdk_metrics2 = require("@opentelemetry/sdk-metrics");
var import_sdk_trace_web2 = require("@opentelemetry/sdk-trace-web");
var import_isEqual = __toESM(require("lodash/isEqual"));
var import_zod3 = require("zod");

// src/instrumentation/fetch.ts
var import_api5 = require("@opentelemetry/api");
var import_core = require("@opentelemetry/core");
var import_instrumentation = require("@opentelemetry/instrumentation");
var import_sdk_trace_web = require("@opentelemetry/sdk-trace-web");
var import_semantic_conventions2 = require("@opentelemetry/semantic-conventions");

// src/utils/fetch.ts
var import_api2 = require("@opentelemetry/api");
var otelLogger = import_api2.diag.createComponentLogger({
  namespace: "\u2728 @e-comm-platform/web-otel-sdk/utils/fetch"
});
var TEXT_ENCODER = new TextEncoder();
var getFetchBodyLength = async (isMeasuringBodyLength, ...args) => {
  try {
    if (!isMeasuringBodyLength) return void 0;
    if (args[0] instanceof URL || typeof args[0] === "string") {
      const requestInit = args[1];
      if (!requestInit?.body) return void 0;
      if (requestInit.body instanceof ReadableStream) {
        const { body, length } = _getBodyNonDestructively(requestInit.body);
        requestInit.body = body;
        return length;
      } else {
        return getXHRBodyLength(requestInit.body);
      }
    } else {
      const info = args[0];
      if (!info?.body) return void 0;
      const text = await info.clone().text();
      return getByteLength(text);
    }
  } catch (error) {
    otelLogger.error("Error in getFetchBodyLength:", error);
    return void 0;
  }
};
var _getBodyNonDestructively = (body) => {
  if (!body.pipeThrough) {
    otelLogger.warn("Platform has ReadableStream but not pipeThrough!");
    return {
      body,
      length: Promise.resolve(void 0)
    };
  }
  let length = 0;
  let resolveLength;
  const lengthPromise = new Promise((resolve) => {
    resolveLength = resolve;
  });
  const transform = new TransformStream({
    start() {
    },
    async transform(chunk, controller) {
      const bytearray = await chunk;
      length += bytearray.byteLength;
      controller.enqueue(chunk);
    },
    flush() {
      resolveLength(length);
    }
  });
  return {
    body: body.pipeThrough(transform),
    length: lengthPromise
  };
};
var isDocument = (value) => {
  return typeof Document !== "undefined" && value instanceof Document;
};
var getXHRBodyLength = (body) => {
  if (isDocument(body)) {
    return new XMLSerializer().serializeToString(document).length;
  }
  if (typeof body === "string") {
    return getByteLength(body);
  }
  if (body instanceof Blob) {
    return body.size;
  }
  if (body instanceof FormData) {
    return getFormDataSize(body);
  }
  if (body instanceof URLSearchParams) {
    return getByteLength(body.toString());
  }
  if (body.byteLength !== void 0) {
    return body.byteLength;
  }
  otelLogger.warn("unknown body type");
  return void 0;
};
var getByteLength = (s) => {
  return TEXT_ENCODER.encode(s).byteLength;
};
var getFormDataSize = (formData) => {
  let size = 0;
  for (const [key, value] of formData.entries()) {
    size += key.length;
    if (value instanceof Blob) {
      size += value.size;
    } else {
      size += value.length;
    }
  }
  return size;
};
var normalizeHeaders = (headers) => {
  if (!headers) return {};
  if (headers instanceof Headers) {
    return Object.fromEntries(headers.entries());
  } else if (Array.isArray(headers)) {
    return Object.fromEntries(headers);
  }
  return { ...headers };
};
var injectRequestHeadersDirectly = (request, traceCarrier, bodyLength) => {
  if (request instanceof Request) {
    Object.entries(traceCarrier).forEach(([key, val]) => {
      request.headers.set(key, val);
    });
    if (bodyLength === 0) request.headers.delete("content-type");
    return request;
  } else {
    return injectRequestInitHeaders(request, traceCarrier);
  }
};
var injectRequestInitHeaders = (request, traceCarrier) => {
  const newRequestInit = { ...request, headers: normalizeHeaders(request.headers) };
  Object.entries(traceCarrier).forEach(([key, val]) => {
    newRequestInit.headers[key] = val;
  });
  return newRequestInit;
};
var injectResponseHeaders = (response, traceCarrier) => {
  const resClone = response.clone();
  const newHeaders = new Headers(resClone.headers);
  Object.entries(traceCarrier).forEach(([key, val]) => {
    newHeaders.set(key, val);
  });
  const newResponse = new Response(resClone.body, {
    // cannot use spread operator, it will mark body as bodyUsed: true
    status: resClone.status,
    statusText: resClone.statusText,
    headers: newHeaders
  });
  return newResponse;
};
var readResponseStream = async (response) => {
  const spanResClone = response.clone();
  if (spanResClone.body) {
    const reader = spanResClone.body.getReader();
    try {
      while (true) {
        const { done } = await reader.read();
        if (done) break;
      }
    } catch (error) {
      throw error;
    }
  }
};

// src/utils/traces.ts
var import_api3 = require("@opentelemetry/api");
var import_api4 = require("@opentelemetry/api");
var otelLogger2 = import_api4.diag.createComponentLogger({
  namespace: "\u2728 @e-comm-platform/web-otel-sdk/utils/traces"
});
var tracer = () => import_api3.trace.getTracer(`${appName}-tracer`);
var setActiveTraceContext = (traceCarrier) => {
  if (!traceCarrier) return;
  return import_api3.propagation.extract(import_api3.context.active(), traceCarrier);
};
var buildTraceCarrier = (span) => {
  const carrier = {};
  const spanContext = span ? import_api3.trace.setSpan(import_api3.context.active(), span) : import_api3.context.active();
  if (isW3CSupported) carrier.tracestate = addTraceState(carrier.tracestate, String(criticalPathsSampled));
  import_api3.propagation.inject(spanContext, carrier);
  return carrier;
};
function addTraceState(traceState, value) {
  if (!value) return traceState;
  return traceState ? `${traceState},${value}` : value;
}

// src/utils/url.ts
var import_escapeRegExp = __toESM(require("lodash/escapeRegExp"));
var isMatchingUrl = (url, matchingUrls) => {
  return matchingUrls?.some((urlToMatch) => {
    if (typeof urlToMatch === "string") {
      return url === urlToMatch;
    } else {
      return !!url.match(urlToMatch);
    }
  }) || false;
};
var getPageUrls = (pageUrlsMap) => {
  return Object.values(pageUrlsMap).filter((pageUrl) => pageUrl !== void 0);
};
var getPageKey = (url, pageUrlsMap) => {
  for (const pageKey in pageUrlsMap) {
    const allowedUrl = pageUrlsMap[pageKey];
    if (isMatchingUrl(url, allowedUrl ? [allowedUrl] : void 0)) {
      return pageKey;
    }
  }
};

// src/instrumentation/fetch.ts
var otelLogger3 = import_api5.diag.createComponentLogger({
  namespace: "\u2728 e-comm-platform/web-otel-sdk/instrumentation/fetch"
});
var OBSERVER_WAIT_TIME_MS = 300;
var CustomFetchInstrumentation = class extends import_instrumentation.InstrumentationBase {
  constructor(config) {
    otelLogger3.info("CustomFetchInstrumentation constructor");
    super("CustomFetchInstrumentation", "1.0.0", config);
    this.component = "fetch";
    this.moduleName = this.component;
    this._usedResources = /* @__PURE__ */ new WeakSet();
    this._tasksCount = 0;
  }
  // resource management
  _clearResources() {
    if (this._tasksCount === 0 && this.getConfig().options.clearTimingResources) {
      performance.clearResourceTimings();
      this._usedResources = /* @__PURE__ */ new WeakSet();
    }
  }
  // span network events and children
  _addSpanResponseAttributes(span, response) {
    const parsedUrl = (0, import_sdk_trace_web.parseUrl)(response.url);
    span.setAttribute(import_semantic_conventions2.SEMATTRS_HTTP_STATUS_CODE, response.status);
    if (response.statusText != null) {
      span.setAttribute("http.status_text", response.statusText);
    }
    span.setAttribute(import_semantic_conventions2.SEMATTRS_HTTP_HOST, parsedUrl.host);
    span.setAttribute(import_semantic_conventions2.SEMATTRS_HTTP_SCHEME, parsedUrl.protocol.replace(":", ""));
    if (typeof navigator !== "undefined") {
      span.setAttribute(import_semantic_conventions2.SEMATTRS_HTTP_USER_AGENT, navigator.userAgent);
    }
  }
  _addSpanNetworkChildren(span, corsPreFlightRequest) {
    const childSpan = this.tracer.startSpan(
      "CORS Preflight",
      {
        startTime: corsPreFlightRequest[import_sdk_trace_web.PerformanceTimingNames.FETCH_START]
      },
      import_api5.trace.setSpan(import_api5.context.active(), span)
    );
    if (childSpan.isRecording()) {
      (0, import_sdk_trace_web.addSpanNetworkEvents)(childSpan, corsPreFlightRequest, this.getConfig().options.ignoreNetworkEvents);
      childSpan.end(corsPreFlightRequest[import_sdk_trace_web.PerformanceTimingNames.RESPONSE_END]);
    }
  }
  _addSpanNetworkEvents(span, spanData, endTime) {
    let resources = spanData.entries;
    if (!resources.length) {
      if (!performance.getEntriesByType) {
        return;
      }
      resources = performance.getEntriesByType("resource");
    }
    const resource = (0, import_sdk_trace_web.getResource)(spanData.url, spanData.startTime, endTime, resources, this._usedResources, "fetch");
    if (resource.mainRequest) {
      const mainRequest = resource.mainRequest;
      this._usedResources.add(mainRequest);
      const corsPreFlightRequest = resource.corsPreFlightRequest;
      if (corsPreFlightRequest) {
        this._addSpanNetworkChildren(span, corsPreFlightRequest);
        this._usedResources.add(corsPreFlightRequest);
      }
      (0, import_sdk_trace_web.addSpanNetworkEvents)(span, mainRequest, this.getConfig().options.ignoreNetworkEvents);
    }
  }
  // span lifecycle
  _startSpan(url, request = {}, bodyLength) {
    try {
      const method = (request.method || "GET").toUpperCase();
      const spanName = `HTTP ${method}`;
      const rootContext = typeof window !== "undefined" ? window.rootContext ?? import_api5.context.active() : import_api5.context.active();
      const span = tracer().startSpan(
        spanName,
        {
          kind: import_api5.SpanKind.CLIENT,
          attributes: {
            ["component"]: this.moduleName,
            [import_semantic_conventions2.SEMATTRS_HTTP_METHOD]: method,
            [import_semantic_conventions2.SEMATTRS_HTTP_URL]: url
          }
        },
        rootContext
      );
      if (this.getConfig().options.measureRequestSize && bodyLength)
        span.setAttribute(import_semantic_conventions2.SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED, bodyLength);
      this._tasksCount++;
      return span;
    } catch (err) {
      otelLogger3.error("Error in startSpan:", err);
    }
  }
  _getSpanData(url) {
    const startTime = (0, import_core.hrTime)();
    const entries = [];
    if (typeof PerformanceObserver !== "function") {
      return { url, startTime, entries };
    }
    const observer = new PerformanceObserver((list) => {
      const perfObsEntries = list.getEntries();
      perfObsEntries.forEach((entry) => {
        if (entry.initiatorType === "fetch" && entry.name === url) {
          entries.push(entry);
        }
      });
    });
    observer.observe({
      entryTypes: ["resource"]
    });
    return { url, startTime, entries, observer };
  }
  _cleanupSpanData(spanData) {
    try {
      this._tasksCount--;
      this._clearResources();
      if (spanData.observer) spanData.observer.disconnect();
    } catch (error) {
      otelLogger3.error("Error disconnecting PerformanceObserver:", error);
    }
  }
  _endSpan(span, spanData, response) {
    if (!span.isRecording()) return;
    const endTime = (0, import_core.millisToHrTime)(Date.now());
    const performanceEndTime = (0, import_core.hrTime)();
    this._addSpanResponseAttributes(span, response);
    setTimeout(() => {
      this._cleanupSpanData(spanData);
      if (!span.isRecording()) return;
      this._addSpanNetworkEvents(span, spanData, performanceEndTime);
      span.end(endTime);
    }, OBSERVER_WAIT_TIME_MS);
  }
  // events
  _callEventHook(startTime, endTime, isFetchError, isMetricsUrl, url) {
    if (!isMetricsUrl) {
      otelLogger3.debug("event hook skipped, not in metrics urls list.");
      return;
    }
    try {
      const startTimeMs = (0, import_core.hrTimeToMilliseconds)(startTime);
      const endTimeMs = (0, import_core.hrTimeToMilliseconds)(endTime);
      const fetchEvent = {
        startTime: startTimeMs,
        endTime: endTimeMs,
        duration: endTimeMs - startTimeMs,
        isError: isFetchError,
        url
      };
      (0, import_instrumentation.safeExecuteInTheMiddle)(
        () => {
          this.getConfig().hooks?.onFetchEvent(fetchEvent);
        },
        (error) => {
          if (error) otelLogger3.error("requestHook", error);
        },
        true
      );
    } catch (hookError) {
      otelLogger3.error("Error in onFetchEvent hook:", hookError);
    }
  }
  _getUrlFlags(pagePath, url) {
    try {
      const ignoredUrls = this.getConfig().urls.ignoredUrls;
      const internalUrls = this.getConfig().urls.internalUrls;
      const externalUrls = this.getConfig().urls.externalUrls;
      const pageUrlsMap = this.getConfig().urls.pageUrlsMap;
      const pageUrls = pageUrlsMap ? getPageUrls(pageUrlsMap) : void 0;
      const isIgnoredUrl = (0, import_core.isUrlIgnored)(url, ignoredUrls);
      const isInternalUrl = (0, import_sdk_trace_web.shouldPropagateTraceHeaders)(url, internalUrls);
      const isExternalUrl = isMatchingUrl(url, externalUrls);
      const isPageUrl = pagePath ? isMatchingUrl(pagePath, pageUrls) : true;
      const isPropagatedUrl = !isIgnoredUrl && isInternalUrl;
      const isMetricsUrl = !isIgnoredUrl && isPageUrl;
      const isTracedUrl = isPropagatedUrl || isExternalUrl || isMetricsUrl;
      return {
        isPropagatedUrl,
        isTracedUrl,
        isMetricsUrl
      };
    } catch (error) {
      otelLogger3.error("Error in getUrlFlags:", error);
      return {
        isPropagatedUrl: false,
        isTracedUrl: false,
        isMetricsUrl: false
      };
    }
  }
  _parseFetchArgs(args) {
    const url = args[0] instanceof Request ? args[0].url : String(args[0]);
    const request = args[0] instanceof Request ? args[0] : args[1] || {};
    try {
      const parsedUrl = (0, import_sdk_trace_web.parseUrl)(url).href;
      return { url: parsedUrl, request };
    } catch (error) {
      otelLogger3.error("Error in parseFetchArgs:", error);
      return { url, request };
    }
  }
  async _handleFetchPrepare(request, url, bodyLength, isPropagatedUrl, isTracedUrl) {
    try {
      const span = isTracedUrl ? this._startSpan(url, request, bodyLength) : void 0;
      const spanData = isTracedUrl ? this._getSpanData(url) : void 0;
      const traceCarrier = buildTraceCarrier(span);
      const newRequest = isPropagatedUrl ? injectRequestHeadersDirectly(request, traceCarrier, bodyLength) : request;
      otelLogger3.info("Fetch Prepare", {
        url,
        isPropagatedUrl,
        requestHeaders: newRequest.headers,
        isSpanRecording: span?.isRecording()
      });
      return { newRequest, span, spanData, traceCarrier };
    } catch (error) {
      otelLogger3.error("Could not inject request headers or start span", error);
      return { newRequest: request, span: void 0, spanData: void 0, traceCarrier: void 0 };
    }
  }
  async _handleFetchSuccess(response, url, span, spanData, traceCarrier, isPropagatedUrl, isTracedUrl, isMetricsUrl) {
    try {
      const isErrorStatus = response.status >= 400;
      if (isMetricsUrl && spanData) this._callEventHook(spanData.startTime, (0, import_core.hrTime)(), isErrorStatus, isMetricsUrl, url);
      const newResponse = isPropagatedUrl && traceCarrier ? injectResponseHeaders(response, traceCarrier) : response;
      try {
        await readResponseStream(response);
        if (isTracedUrl && span && spanData) {
          if (isErrorStatus) span.recordException({ code: response.status, message: response.statusText });
          this._endSpan(span, spanData, {
            status: response.status,
            statusText: response.statusText,
            url
          });
        }
      } catch (error) {
        if (isTracedUrl && span && spanData) {
          if (isErrorStatus) span.recordException({ code: response.status, message: response.statusText });
          this._endSpan(span, spanData, {
            status: error.status || 0,
            statusText: error.message,
            url
          });
        }
      }
      otelLogger3.info("Fetch Success", {
        url,
        isPropagatedUrl,
        responseHeaders: newResponse.headers,
        isSpanRecording: span?.isRecording()
      });
      return newResponse;
    } catch (error) {
      otelLogger3.error("Could not inject response headers or end success span", error);
      return response;
    }
  }
  async _handleFetchError(error, url, span, spanData, isTracedUrl, isMetricsUrl) {
    try {
      otelLogger3.info("Fetch Error", { url, isRecording: span?.isRecording(), isTracedUrl, isMetricsUrl });
      if (isMetricsUrl && spanData) this._callEventHook(spanData.startTime, (0, import_core.hrTime)(), true, isMetricsUrl, url);
      if (isTracedUrl && span?.isRecording() && spanData) {
        span.recordException(error);
        span.setStatus({
          code: import_api5.SpanStatusCode.ERROR,
          message: error.message
        });
        this._endSpan(span, spanData, {
          status: error.status || 0,
          statusText: error.message,
          url
        });
      }
      otelLogger3.info("Fetch Error", {
        url,
        error,
        isSpanRecording: span?.isRecording()
      });
    } catch (instrumentError) {
      otelLogger3.error("Could not end error span", instrumentError);
      if (isTracedUrl && span && spanData) this._cleanupSpanData(spanData);
    }
    otelLogger3.error("Fetch error", { url, isRecording: span?.isRecording(), isTracedUrl, isMetricsUrl }, error);
    return error;
  }
  _handleActiveContext(isTracedUrl, span, asyncCallback) {
    return isTracedUrl && span ? import_api5.context.with(import_api5.trace.setSpan(import_api5.context.active(), span), asyncCallback) : asyncCallback();
  }
  _patchConstructor() {
    return (original) => {
      const instrumentThis = this;
      return async function patchConstructor(...args) {
        const fetchThis = this;
        const { url, request } = instrumentThis._parseFetchArgs(args);
        const bodyLength = await getFetchBodyLength(instrumentThis.getConfig().options.measureRequestSize, ...args);
        const pagePath = typeof window !== "undefined" ? window.location.pathname : void 0;
        const { isPropagatedUrl, isTracedUrl, isMetricsUrl } = instrumentThis._getUrlFlags(pagePath, url);
        const { newRequest, span, spanData, traceCarrier } = await instrumentThis._handleFetchPrepare(
          request,
          url,
          bodyLength,
          isPropagatedUrl,
          isTracedUrl
        );
        return new Promise((resolve, reject) => {
          return instrumentThis._handleActiveContext(isTracedUrl, span, () => {
            return original.apply(fetchThis, newRequest instanceof Request ? [newRequest] : [url, newRequest]).then(async function onSuccess(response) {
              const newResponse = await instrumentThis._handleFetchSuccess(
                response,
                url,
                span,
                spanData,
                traceCarrier,
                isPropagatedUrl,
                isTracedUrl,
                isMetricsUrl
              );
              resolve(newResponse);
            }).catch(async function onError(error) {
              const newError = await instrumentThis._handleFetchError(
                error,
                url,
                span,
                spanData,
                isTracedUrl,
                isMetricsUrl
              );
              reject(newError);
            });
          });
        });
      };
    };
  }
  // lifecycle
  init() {
  }
  enable() {
    try {
      otelLogger3.info("CustomFetchInstrumentation enable");
      if ((0, import_instrumentation.isWrapped)(fetch)) {
        this._unwrap(import_core._globalThis, "fetch");
        otelLogger3.debug("removing previous patch for constructor");
      }
      this._wrap(import_core._globalThis, "fetch", this._patchConstructor());
    } catch (error) {
      otelLogger3.error("Error in instrumentation enable:", error);
    }
  }
  disable() {
    try {
      otelLogger3.info("CustomFetchInstrumentation disable");
      this._unwrap(import_core._globalThis, "fetch");
      this._usedResources = /* @__PURE__ */ new WeakSet();
    } catch (error) {
      otelLogger3.error("Error in instrumentation disable:", error);
    }
  }
};

// src/instrumentation/load.ts
var import_router = __toESM(require("next/router"));
var import_api6 = require("@opentelemetry/api");
var import_core2 = require("@opentelemetry/core");
var import_instrumentation2 = require("@opentelemetry/instrumentation");

// src/utils/setup.ts
var getExtendedAttributes = (pathName, bannerId, userId) => ({
  ...resourceAttributes,
  "ld.path": pathName,
  "ld.banner": bannerId,
  "ld.user.id": userId
});
var queryDomJson = (selector) => {
  try {
    const text = document.querySelector(selector)?.textContent?.replace(/;$/, "");
    return text ? JSON.parse(text) : void 0;
  } catch (err) {
    console.error("queryDomJson", { selector, err });
    return void 0;
  }
};
var getOtelCarrierFromDom = () => {
  const domTraceCarrier = queryDomJson("#otel-trace-carrier");
  const domMeterCarrier = queryDomJson("#otel-meter-carrier");
  const domFeatureFlags = queryDomJson("#otel-feature-flags");
  const domNextData = queryDomJson("#__NEXT_DATA__");
  const nextData = domNextData || window.__NEXT_DATA__;
  const traceCarrier = domTraceCarrier || void 0;
  const meterCarrier = domMeterCarrier || nextData?.props?.pageProps?.meterCarrier;
  const featureFlags = domFeatureFlags || defaultFeatureFlags;
  const result = {
    traceCarrier,
    meterCarrier,
    featureFlags
  };
  return result;
};

// src/instrumentation/load.ts
var otelLogger4 = import_api6.diag.createComponentLogger({
  namespace: "\u2728 e-comm-platform/web-otel-sdk/instrumentation/load"
});
var CustomLoadInstrumentation = class extends import_instrumentation2.InstrumentationBase {
  constructor(config) {
    otelLogger4.info("CustomLoadInstrumentation constructor");
    super("CustomLoadInstrumentation", "1.0.0", config);
    this.isFirstInit = true;
    this.boundHandleInit = this.handleInit.bind(this);
    this.boundHandleRendered = this.handleRendered.bind(this);
  }
  // helpers
  _createActiveRootSpan(name, startTime) {
    const { traceCarrier } = getOtelCarrierFromDom();
    const activeTraceContext = setActiveTraceContext(traceCarrier);
    const pageSpan = tracer().startSpan(name, { startTime }, activeTraceContext);
    const rootContext = import_api6.trace.setSpan(import_api6.context.active(), pageSpan);
    window.rootContext = rootContext;
    return pageSpan;
  }
  _findLoadedElements(newPathName) {
    try {
      const pageLoadedSelectors = this.pageKey ? this.getConfig().options.pageLoadedSelectorsMap[this.pageKey] : [];
      if (pageLoadedSelectors.length === 0) {
        clearInterval(this.renderedTimer);
        return;
      }
      const pageFailedSelectors = this.pageKey ? this.getConfig().options.pageFailedSelectors : [];
      if (pageLoadedSelectors.length === 0 || pageFailedSelectors.length === 0) return;
      const isLoadedElementsExists = pageLoadedSelectors.every((selector) => !!document?.querySelector(selector));
      const isFailedElementsExists = pageFailedSelectors.some((selector) => !!document?.querySelector(selector));
      const isPageLoaded = isLoadedElementsExists || isFailedElementsExists;
      const isPageFailed = isFailedElementsExists;
      if (!isPageLoaded) return;
      clearInterval(this.renderedTimer);
      this.handleRendered(newPathName, isPageFailed);
    } catch (error) {
      otelLogger4.error("Error in load check dom handler:", error);
    }
  }
  // handlers
  handleInit(newPathName) {
    try {
      const ignoredUrls = this.getConfig().options.ignoredUrls;
      const pageUrls = getPageUrls(this.getConfig().options.pageUrlsMap);
      const isIgnoredUrl = (0, import_core2.isUrlIgnored)(newPathName, ignoredUrls);
      const isPageUrl = isMatchingUrl(newPathName, pageUrls);
      const isMetricsUrl = !isIgnoredUrl && isPageUrl;
      const isTracedUrl = isMetricsUrl;
      otelLogger4.info("handleInit", { newPathName, pageUrls });
      if (this.pagePathName === newPathName) {
        otelLogger4.info("Page already initialized, skipping render check", { newPathName });
        return;
      }
      if (this.pageSpan?.isRecording()) {
        this.pageSpan.end(performance.now());
        this.pageSpan = void 0;
      }
      this.pageKey = getPageKey(newPathName, this.getConfig().options.pageUrlsMap);
      this.pagePathName = newPathName;
      this.pageInitMs = this.isFirstInit ? 0 : performance.now();
      this.pageRenderedMs = void 0;
      this.isFirstInit = false;
      if (this.renderedTimer) {
        clearInterval(this.renderedTimer);
        this.renderedTimer = void 0;
      }
      if (!isPageUrl || !this.pageKey) {
        otelLogger4.info("Invalid page, skipping, skipping render check", { newPathName, pageUrls });
        return;
      }
      if (isTracedUrl) this.pageSpan = this._createActiveRootSpan("Page Load", this.pageInitMs);
      if (!isMetricsUrl) return;
      this.getConfig().hooks.onInitEvent(this.pagePathName, this.pageKey);
      const pageSelectorsIntervalMs = this.getConfig().options.pageSelectorsIntervalMs;
      this.renderedTimer = setInterval(() => this._findLoadedElements(newPathName), pageSelectorsIntervalMs);
    } catch (error) {
      otelLogger4.error("Error in Page Init handler:", error);
    }
  }
  handleRendered(newPathName, pageFailed) {
    try {
      if (this.pagePathName !== newPathName || this.pageInitMs === void 0 || !this.pageKey) return;
      otelLogger4.info("handleRendered", {
        newPathName,
        pagePathName: this.pagePathName,
        pageInitMs: this.pageInitMs,
        pageKey: this.pageKey,
        pageFailed
      });
      this.pageRenderedMs = performance.now();
      let traceId = this.pageSpan?.spanContext()?.traceId;
      if (this.pageSpan?.isRecording()) {
        this.pageSpan?.end(this.pageRenderedMs);
        this.pageSpan = void 0;
      }
      const pageLoadDurationMs = this.pageRenderedMs - this.pageInitMs;
      this.getConfig().hooks.onRenderedEvent(
        this.pagePathName,
        this.pageKey,
        this.pageInitMs,
        this.pageRenderedMs,
        pageLoadDurationMs,
        pageFailed,
        traceId
      );
    } catch (error) {
      otelLogger4.error("Error in Page Rendered handler:", error);
    }
  }
  // lifecycle
  init() {
  }
  enable() {
    try {
      otelLogger4.info("CustomLoadInstrumentation enable");
      if (typeof window === "undefined") return;
      setTimeout(() => {
        otelLogger4.info("Binding handleInit to routeChangeStart");
        import_router.default.events.on("routeChangeStart", this.boundHandleInit);
      }, 1);
    } catch (error) {
      otelLogger4.error("Error in instrumentation enable:", error);
    }
  }
  disable() {
    try {
      otelLogger4.info("CustomLoadInstrumentation disable");
      if (typeof window === "undefined") return;
      if (this.renderedTimer) clearInterval(this.renderedTimer);
      if (this.boundHandleInit) {
        otelLogger4.info("Unbinding handleInit from routeChangeStart");
        import_router.default.events.off("routeChangeStart", this.boundHandleInit);
      }
    } catch (error) {
      otelLogger4.error("Error in instrumentation disable:", error);
    }
  }
};

// src/processors/dynamic-logs-exporter.ts
var import_core3 = require("@opentelemetry/core");
var import_exporter_logs_otlp_http = require("@opentelemetry/exporter-logs-otlp-http");
var DynamicLoggingExporter = class {
  constructor(loggingUrl2, isEnabled, headers) {
    this.enabled = isEnabled;
    this.loggingUrl = loggingUrl2;
    this.headers = headers;
    this.exporter = null;
    if (isEnabled) {
      this.exporter = this.createLoggingExporter();
    }
  }
  // ✅ Dynamically enable or disable metric exporting
  enable() {
    if (this.enabled) {
      return;
    }
    this.exporter = this.createLoggingExporter();
    this.enabled = true;
  }
  createLoggingExporter() {
    const exporterOptions = {
      url: this.loggingUrl,
      headers: this.headers
    };
    return new import_exporter_logs_otlp_http.OTLPLogExporter(exporterOptions);
  }
  disable() {
    this.exporter = null;
    this.enabled = false;
  }
  export(logs, resultCallback) {
    if (this.enabled && this.exporter) {
      this.exporter.export(logs, resultCallback);
    } else {
      resultCallback({ code: import_core3.ExportResultCode.SUCCESS });
    }
  }
  /** Stops the exporter. */
  shutdown() {
    return this.exporter ? this.exporter.shutdown() : Promise.resolve();
  }
};

// src/processors/dynamic-metric-exporter.ts
var import_core4 = require("@opentelemetry/core");
var import_exporter_metrics_otlp_http = require("@opentelemetry/exporter-metrics-otlp-http");
var import_sdk_metrics = require("@opentelemetry/sdk-metrics");
var DynamicMetricExporter = class {
  constructor(metricsUrl2, isEnabled, headers, temporalityPreference) {
    this.enabled = isEnabled;
    this.metricsUrl = metricsUrl2;
    this.headers = headers;
    this.temporalityPreference = temporalityPreference;
    this.exporter = null;
    if (isEnabled) {
      this.exporter = this.createMetricExporter();
    }
  }
  // ✅ Dynamically enable or disable metric exporting
  enable() {
    if (this.enabled) {
      return;
    }
    this.exporter = this.createMetricExporter();
    this.enabled = true;
  }
  createMetricExporter() {
    const exporterOptions = {
      url: this.metricsUrl,
      headers: this.headers
    };
    if (this.temporalityPreference !== void 0) {
      exporterOptions.temporalityPreference = this.temporalityPreference;
    }
    return new import_exporter_metrics_otlp_http.OTLPMetricExporter(exporterOptions);
  }
  disable() {
    this.exporter = null;
    this.enabled = false;
  }
  export(metrics3, resultCallback) {
    if (this.enabled && this.exporter) {
      this.exporter.export(metrics3, resultCallback);
    } else {
      resultCallback({ code: import_core4.ExportResultCode.SUCCESS });
    }
  }
  forceFlush() {
    return this.exporter ? this.exporter.forceFlush() : Promise.resolve();
  }
  shutdown() {
    return this.exporter ? this.exporter.shutdown() : Promise.resolve();
  }
  selectAggregationTemporality(instrumentType) {
    return this.exporter ? this.exporter.selectAggregationTemporality(instrumentType) : import_sdk_metrics.AggregationTemporality.CUMULATIVE;
  }
  selectAggregation(instrumentType) {
    return this.exporter ? this.exporter.selectAggregation(instrumentType) : import_sdk_metrics.Aggregation.Default();
  }
};

// src/processors/flush.ts
var setupCSRTelemetryFlush = ({ tracerProvider, meterProvider }) => {
  if (typeof window === "undefined") return;
  const handleBeforeUnload = async () => {
    try {
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error("Flush timeout")), 2e3);
      });
      await Promise.race([Promise.all([tracerProvider.forceFlush(), meterProvider.forceFlush()]), timeoutPromise]);
      console.debug("Successfully flushed OpenTelemetry data");
    } catch (error) {
      console.error("Failed to flush OpenTelemetry data:", error);
    }
  };
  window.addEventListener("beforeunload", handleBeforeUnload);
  return () => {
    window.removeEventListener("beforeunload", handleBeforeUnload);
  };
};

// src/schemas/setup.ts
var import_zod = require("zod");
var featureFlagsSchema = import_zod.z.object({
  status: import_zod.z.boolean(),
  traceSamplingRatio: import_zod.z.number(),
  alwaysOnTracingUserIds: import_zod.z.array(import_zod.z.string())
});

// src/schemas/url.ts
var import_zod2 = require("zod");
var traceUrlSchema = import_zod2.z.string().nonempty().or(import_zod2.z.instanceof(RegExp));

// src/utils/logger.ts
var consoleMap = [
  { n: "error", c: "error" },
  { n: "warn", c: "warn" },
  { n: "info", c: "info" },
  { n: "debug", c: "debug" },
  { n: "verbose", c: "trace" }
];
var CustomDiagConsoleLogger = class {
  constructor(options = { stringify: false }) {
    function _consoleFunc(funcName) {
      return function(...args) {
        if (console) {
          let theFunc = console[funcName];
          if (typeof theFunc !== "function") {
            theFunc = console.log;
          }
          if (typeof theFunc === "function") {
            const stringifiedArgs = options.stringify ? [args[0], ...args.slice(1).map((arg) => JSON.stringify(arg))] : args;
            return theFunc.apply(console, stringifiedArgs);
          }
        }
      };
    }
    for (let i = 0; i < consoleMap.length; i++) {
      this[consoleMap[i].n] = _consoleFunc(consoleMap[i].c);
    }
  }
};

// src/setup/csr.ts
var otelLogger5 = import_api7.diag.createComponentLogger({
  namespace: "\u2728 @e-comm-platform/web-otel-sdk/setup/csr"
});
if (!isNodeRuntime && isOtelDebugLogging) {
  import_api7.diag.setLogger(new CustomDiagConsoleLogger({ stringify: false }), {
    logLevel: import_api7.DiagLogLevel.INFO,
    suppressOverrideMessage: true
  });
}
var isOtelInitialized = false;
var dynamicMetricExporter = null;
var lastFeatureFlags = void 0;
var handleLoadInit;
var loggerProvider = null;
var dynamicLoggingExporter = null;
var setupCsrOtelSchema = import_zod3.z.object({
  ignoredUrls: import_zod3.z.array(traceUrlSchema).optional(),
  internalUrls: import_zod3.z.array(traceUrlSchema),
  externalUrls: import_zod3.z.array(traceUrlSchema).optional(),
  pageUrlsMap: import_zod3.z.record(import_zod3.z.string(), traceUrlSchema),
  pageLoadedSelectorsMap: import_zod3.z.record(import_zod3.z.string(), import_zod3.z.array(import_zod3.z.string().nonempty())),
  pageFailedSelectors: import_zod3.z.array(import_zod3.z.string().nonempty()),
  getUserId: import_zod3.z.function().returns(import_zod3.z.string()).optional(),
  getBannerId: import_zod3.z.function().args(import_zod3.z.string()).returns(import_zod3.z.string()).optional()
});
var setupCsrOtel = async (props) => {
  const {
    pageUrlsMap,
    pageLoadedSelectorsMap,
    pageFailedSelectors,
    internalUrls,
    externalUrls,
    ignoredUrls,
    getUserId,
    getBannerId
  } = props;
  const propsValidationResult = setupCsrOtelSchema.safeParse(props);
  const isOtelUrlsValid = [tracesUrl, metricsUrl, loggingUrl].every((url) => !!url && url !== "invalid-url");
  if (isJestRuntime || isNodeRuntime || isOtelInitialized || !propsValidationResult.success || !isOtelUrlsValid) {
    if (!isNodeRuntime)
      console.error(`Otel setup failed for '${appName}' - CSR`, {
        isJestRuntime,
        isNodeRuntime,
        isOtelInitialized,
        internalUrls,
        propsValidationResult
      });
    return;
  }
  const filteredIgnoredUrls = ignoredUrls?.filter((url) => url !== void 0);
  const filteredInternalUrls = internalUrls.filter((url) => url !== void 0);
  const filteredExternalUrls = externalUrls?.filter((url) => url !== void 0);
  const { featureFlags } = getOtelCarrierFromDom();
  isOtelInitialized = true;
  const resource = new import_resources.Resource(resourceAttributes).merge(
    (0, import_resources.detectResourcesSync)({
      detectors: [import_resources.envDetector, import_resources.hostDetector, import_resources.osDetector]
    })
  );
  dynamicLoggingExporter = new DynamicLoggingExporter(loggingUrl, featureFlags?.status ?? false, {});
  const tracerProvider = new import_sdk_trace_web2.WebTracerProvider({
    resource,
    sampler: new import_sdk_trace_web2.ParentBasedSampler({
      root: new import_sdk_trace_web2.AlwaysOffSampler()
    }),
    spanProcessors: [
      ...isOtelEnabled ? [
        new import_sdk_trace_web2.BatchSpanProcessor(
          new import_exporter_trace_otlp_http.OTLPTraceExporter({
            url: tracesUrl,
            headers: defaultHeaders
          })
        )
      ] : [],
      ...isOtelEnabled && isOtelExportLogging ? [new import_sdk_trace_web2.BatchSpanProcessor(new import_sdk_trace_web2.ConsoleSpanExporter())] : []
    ]
  });
  dynamicMetricExporter = new DynamicMetricExporter(
    metricsUrl,
    featureFlags?.status ?? false,
    defaultHeaders,
    import_exporter_metrics_otlp_http2.AggregationTemporalityPreference.DELTA
  );
  const meterProvider = new import_sdk_metrics2.MeterProvider({
    resource,
    readers: [
      ...isOtelEnabled ? [
        new import_sdk_metrics2.PeriodicExportingMetricReader({
          exporter: dynamicMetricExporter,
          exportIntervalMillis: metricsIntervalMs
        })
      ] : [],
      ...isOtelEnabled && isOtelExportLogging ? [
        new import_sdk_metrics2.PeriodicExportingMetricReader({
          exporter: new import_sdk_metrics2.ConsoleMetricExporter(),
          exportIntervalMillis: 1e3
        })
      ] : []
    ]
  });
  const propagator = new import_core5.CompositePropagator({
    propagators: [
      ...isW3CSupported ? [new import_core5.W3CTraceContextPropagator()] : [],
      ...isW3CSupported ? [new import_core5.W3CBaggagePropagator()] : [],
      new import_propagator_b3.B3Propagator({
        injectEncoding: import_propagator_b3.B3InjectEncoding.SINGLE_HEADER
      })
    ]
  });
  const instrumentations = {
    load: new CustomLoadInstrumentation({
      options: {
        ignoredUrls: filteredIgnoredUrls,
        pageUrlsMap,
        pageLoadedSelectorsMap,
        pageFailedSelectors,
        pageSelectorsIntervalMs: 300
      },
      hooks: {
        onInitEvent: handleInitEvent(getUserId, getBannerId),
        onRenderedEvent: handleRenderedEvent(getUserId, getBannerId)
      }
    }),
    fetch: new CustomFetchInstrumentation({
      options: {
        clearTimingResources: true,
        ignoreNetworkEvents: false,
        measureRequestSize: false
      },
      urls: {
        ignoredUrls: [tracesUrl, metricsUrl, loggingUrl, ...filteredIgnoredUrls ?? []],
        internalUrls: filteredInternalUrls,
        externalUrls: filteredExternalUrls,
        pageUrlsMap
      },
      hooks: {
        onFetchEvent: handleFetchEvent
      }
    })
  };
  loggerProvider = new import_sdk_logs.LoggerProvider({
    resource,
    forceFlushTimeoutMillis: 1e3,
    logRecordLimits: {
      attributeValueLengthLimit: 1e3,
      attributeCountLimit: 50
    }
  });
  loggerProvider.addLogRecordProcessor(new import_sdk_logs.SimpleLogRecordProcessor(dynamicLoggingExporter));
  loggerProvider.addLogRecordProcessor(new import_sdk_logs.SimpleLogRecordProcessor(new import_sdk_logs.ConsoleLogRecordExporter()));
  (0, import_instrumentation3.registerInstrumentations)({
    tracerProvider,
    meterProvider,
    loggerProvider,
    instrumentations: Object.values(instrumentations)
  });
  handleLoadInit = instrumentations.load.boundHandleInit;
  setupCSRTelemetryFlush({ tracerProvider, meterProvider });
  tracerProvider.register({
    contextManager: new import_sdk_trace_web2.StackContextManager(),
    propagator
  });
  import_api7.metrics.setGlobalMeterProvider(meterProvider);
  console.log(`Otel setup for '${appName}' - CSR`, {
    exporting: isOtelEnabled,
    tracesUrl,
    metricsUrl,
    ignoredUrls,
    internalUrls,
    externalUrls,
    pageUrlsMap,
    pageLoadedSelectorsMap
  });
};
var updateCsrFeatureFlags = async (newFeatureFlags) => {
  try {
    const validationResult = featureFlagsSchema.safeParse(newFeatureFlags);
    if (!newFeatureFlags || !validationResult.success) {
      otelLogger5.error("Invalid feature flags", { newFeatureFlags, validationResult });
      return;
    }
    if ((0, import_isEqual.default)(newFeatureFlags, lastFeatureFlags)) return;
    otelLogger5.info("Updating CSR Otel feature flags", { newFeatureFlags, lastFeatureFlags });
    lastFeatureFlags = newFeatureFlags;
    if (newFeatureFlags.status) {
      dynamicMetricExporter?.enable();
    } else {
      dynamicMetricExporter?.disable();
    }
    if (handleLoadInit) handleLoadInit(window.location.pathname);
    handleLoadInit = void 0;
  } catch (err) {
    otelLogger5.error("Error updating CSR Otel feature flags", { err });
  }
};

// src/utils/otel-logger.ts
var otelLogging = import_api8.diag.createComponentLogger({
  namespace: "\u2728 @telemetry-sdk/utils/otel-logging"
});
function emitOtelLog(message, bannerId, pageKey, userId, traceId) {
  if (!loggerProvider) {
    return;
  }
  try {
    let attributes = {
      ...getExtendedAttributes(pageKey, bannerId, userId),
      "ld.trace.id": traceId,
      pageKey
    };
    loggerProvider.getLogger("default").emit({
      severityNumber: import_api_logs.SeverityNumber.ERROR,
      severityText: "ERROR",
      body: message,
      attributes,
      timestamp: Date.now()
    });
  } catch (loggingError) {
    otelLogging.error("Failed to log error to OpenTelemetry:", loggingError);
    otelLogging.error("Original error message:", message);
  }
}

// src/events/csr.ts
var otelLogger6 = import_api9.diag.createComponentLogger({
  namespace: "\u2728 @e-comm-platform/web-otel-sdk/events/csr"
});
var handleFetchEvent = (fetchEvent) => {
  otelLogger6.info("Handle Fetch Event:", fetchEvent);
  const { addFetchEvent } = useCsrStore.getState();
  addFetchEvent(fetchEvent);
};
var handleInitEvent = (getUserId, getBannerId) => (pagePathName, pageKey) => {
  otelLogger6.info("Handle Init Event");
  const { initStore } = useCsrStore.getState();
  initStore();
  const userId = getUserId?.() ?? defaultUserId;
  const bannerId = getBannerId?.(pagePathName) ?? defaultBannerId;
  const attributes = getExtendedAttributes(pageKey, bannerId, userId);
  getOpTotalCounter(pageKey).add(1, attributes);
};
var handleRenderedEvent = (getUserId, getBannerId) => (pagePathName, pageKey, pageInitMs, pageRenderedMs, pageLoadDurationMs, isPageFailed, traceId) => {
  const { fetchEvents } = useCsrStore.getState();
  otelLogger6.info("Handle Rendered Event", {
    pagePathName,
    pageKey,
    pageInitMs,
    pageRenderedMs,
    pageLoadDurationMs,
    isPageFailed
  });
  const { meterCarrier } = getOtelCarrierFromDom();
  const ssrFetchDurationMs = meterCarrier?.ssrFetchDurationMs || 0;
  const csrFetchDurationMs = getFetchEventsDuration(fetchEvents);
  const fetchDurationMs = ssrFetchDurationMs + csrFetchDurationMs;
  const finalNetworkDurationMs = Math.min(fetchDurationMs || 0, pageLoadDurationMs || 0);
  const hasCsrFetchErrors = fetchEvents.some((event) => event.isError) || isPageFailed;
  const hasSsrFetchErrors = (meterCarrier?.backendFetchErrors ?? 0) > 0;
  const hasFetchErrors = hasCsrFetchErrors || hasSsrFetchErrors;
  const hasSloError = pageLoadDurationMs > loadSLOThreshold;
  const hasAggregateError = hasFetchErrors || hasSloError;
  const userId = getUserId?.() ?? defaultUserId;
  const bannerId = getBannerId?.(pagePathName) ?? defaultBannerId;
  const attributes = getExtendedAttributes(pageKey, bannerId, userId);
  if (hasFetchErrors) getOpErrorsCounter(pageKey).add(1, attributes);
  getOpDurationHistogram(pageKey).record(pageLoadDurationMs / 1e3, attributes);
  getOpNetworkDurationHistogram(pageKey).record(finalNetworkDurationMs / 1e3, attributes);
  if (hasSloError) {
    getOpSloErrorsCounter(pageKey).add(1, attributes);
    emitOtelLog("SLO error occurred.", bannerId, pageKey, userId, traceId);
  }
  if (hasAggregateError) {
    getOpAggregateErrorsCounter(pageKey).add(1, attributes);
    emitOtelLog("Aggregate error occurred.", bannerId, pageKey, userId, traceId);
  }
  otelLogger6.info("Handle Rendered Event: Log Timings", {
    pageInitMs,
    pageRenderedMs,
    pageLoadDurationMs,
    fetchDurationMs,
    ssrFetchDurationMs,
    csrFetchDurationMs,
    hasCsrFetchErrors,
    hasSsrFetchErrors,
    hasFetchErrors,
    hasSloError,
    hasAggregateError
  });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  OtelCarrier,
  handleFetchEvent,
  handleInitEvent,
  handleRenderedEvent,
  loggerProvider,
  setupCsrOtel,
  updateCsrFeatureFlags
});
